module.exports = __webpack_public_path__ + "media/icons/first-to-review-6326b5b7.svg";